import { gql, TypedDocumentNode } from "@apollo/client";

import {
  BlueprintParseResult,
  Template,
  MutationTemplateVersionParseTemplateArgs,
  QueryTemplateArgs,
} from "types/generated";

type ValidateTemplateVersionTemplateData = {
  templateVersionParseTemplate: BlueprintParseResult;
};

export const VALIDATE_BLUEPRINT_VERSION_TEMPLATE: TypedDocumentNode<
  ValidateTemplateVersionTemplateData,
  MutationTemplateVersionParseTemplateArgs
> = gql`
  mutation ValidateBlueprintVersionTemplate($template: String!) {
    templateVersionParseTemplate(template: $template) {
      errors
      inputs {
        id
        name
        default
        description
        options
        type
        validations {
          greaterThan
          greaterThanOrEqual
          lengthEqual
          lessThan
          lessThanOrEqual
          maxLength
          minLength
          notEqual
          pattern
          required
          step
        }
      }
    }
  }
`;

type GetTemplateVersionData = {
  template: Template;
  templateSchema: string;
};

export const GET_TEMPLATE_VERSION: TypedDocumentNode<
  GetTemplateVersionData,
  QueryTemplateArgs & { versionId: string }
> = gql`
  query GetTemplateVersion($id: ID!, $versionId: ID!) {
    template(id: $id) {
      id
      allowedActions
      name
      space {
        id
        name
        accessLevel
      }
      templateVersion(id: $versionId) {
        id
        deleted
        name
        createdAt
        updatedAt
        instructions
        state
        inputs {
          id
          name
          default
          description
          options
          type
          validations {
            greaterThan
            greaterThanOrEqual
            lengthEqual
            lessThan
            lessThanOrEqual
            maxLength
            minLength
            notEqual
            pattern
            required
            step
          }
        }
        space {
          id
          name
          accessLevel
        }
        labels
        rawTemplate
        version
        deploymentsCount
        deprecatedAt
        deprecationNote
      }
      space {
        id
        name
        accessLevel
      }
    }
    templateSchema
  }
`;
